module.exports = __webpack_public_path__ + "img/smart-community.e3a37810.jpg";